import { render, staticRenderFns } from "./RoomDetails.vue?vue&type=template&id=7f0ba21e&scoped=true"
import script from "./RoomDetails.vue?vue&type=script&lang=js"
export * from "./RoomDetails.vue?vue&type=script&lang=js"
import style0 from "./RoomDetails.vue?vue&type=style&index=0&id=7f0ba21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ba21e",
  null
  
)

export default component.exports